import React from 'react';
import Button from 'components/v1-tailwindcss/ButtonV1';
import Link from 'next/link'
import Styles from './styles.js';

const NewWelcome = (props) => {
    const { hello, title, discription,href } = props
    return (
        <>

            <div className='lg:container mx-auto px-6  mt-12 pt-12'>
                <div className='w-full grid grid-cols-12 px-6 lg:px-0'>
                    <div className='lg:col-span-8 col-span-12 lg:px-4'>
                        <p className='hello text-sm leading-5 font-normal  mb-8' >{hello}</p>
                        <h3 className='title_head   font-normal  mb-11'>{title}</h3>
                        <p className='hello_disc text-2xl font-normal leading-9  mb-11'>{discription}</p>

                        <div>
                            {/* <Button btntext="Find Properties" /> */}
                                <Button btnName="Find Properties"
                                    px="px-8"
                                    py="py-3"
                                    txtColor="rgb(1, 1, 1)"
                                    mdWidth="auto"
                                    acWidth="full"
                                    justify="center"
                                    btnHref={href} />

                           

                        </div>
                    </div>

                </div>
            </div>
            <Styles/>

        </>
    );
};

export default NewWelcome;
